import { PLANS_DECORATIONS_MAP } from 'constants/plans-decorations-map'
import type { OnboardingType } from 'models/lead.model'
import type { IPlanDecoration } from 'models/plan-decoration.model'

export const getPlanDecoration = ({
  cohort,
  currency,
  onboardingType,
  planName,
}: {
  cohort: string
  currency: string
  onboardingType: OnboardingType | undefined
  planName: string | undefined
}): IPlanDecoration | null => {
  if (!cohort || !currency || !onboardingType || !planName) return null

  return (
    PLANS_DECORATIONS_MAP[cohort]?.[currency]?.[onboardingType]?.find(
      (d) => d.name === planName,
    ) || null
  )
}
